import { persistent } from '../../services/LocalStorage'
import { Features, canaryFeatures } from '../../services/CanaryFeatures'
import { AudioEngineImpl, IAudioEngine } from './IAudioEngine'
import { AudioEngine } from './AudioEngine'
import { WebAudioEngine } from './WebAudioEngine'
import { HybridAudioEngine } from './HybridAudioEngine'
import { isElectron } from '../../utlis/isElectron'

export type { IAudioEngineRoom, AudioEngineRelayServer } from './IAudioEngineRoom'
export type {
    AudioEngineRemoteStreamStats,
    AudioEngineLocalStreamStats,
    AudioEngineState,
    AudioEngineNetworkStats,
    AudioEngineStreamStatsEvent,
    AudioEngineConnectionState,
    AudioEngineAudioDeviceInfo,
    AudioPatch,
} from './types'

export { AudioEngineError } from './types'

export type { IAudioEngine } from './IAudioEngine'

var audioEngine: IAudioEngine | null = null

export function getAudioEngineInstance(): IAudioEngine {
    if (audioEngine === null) {
        let impl = getImpl()

        const forceImpl = persistent.getString('forceAudioEngineImplementation')
        if (forceImpl) {
            /* @ts-ignore */
            impl = forceImpl
        }

        switch (impl) {
            case 'native':
                audioEngine = new AudioEngine()
                break
            case 'web':
                audioEngine = new WebAudioEngine()
                break
            case 'hybrid':
                audioEngine = new HybridAudioEngine()
                break
            default:
                throw new Error(`Unknown audio engine implementation: '${impl}'`)
        }

        audioEngine.init()
    }

    return audioEngine
}

function getImpl(): AudioEngineImpl {
    if (isElectron()) {
        if (canaryFeatures.getSync(Features.HybridAudioEngine)) {
            return 'hybrid'
        }
        return 'native'
    }
    return 'web'
}
